import { configurationConstants } from "../_constants";

const defaultState = {
  documentUploadInfo: null,
  serviceUrls: null,
  supportInfo: null,
  isLPXInMaintenance: false,
};
export function configuration(state = defaultState, action) {
  switch (action.type) {
    case configurationConstants.SUCCESS: {
      const { sharedConfiguration } = action;
      return {
        ...state,
        ...sharedConfiguration,
      };
    }
    case configurationConstants.ERROR:
      return {
        ...defaultState,
      };
    case configurationConstants.IS_LPX_IN_MAINTENANCE_SUCCESS:
      const { isLPXInMaintenance } = action;
      return {
        ...state,
        isLPXInMaintenance,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/configuration.reducer.js